<template>
  <section class="container package-section pt-60">
    <div class="row y-gap-20 justify-between items-center ">
      <div class="row y-gap-20 justify-between items-center">
        <div>
          <div class="sectionTitle mb-30" v-if="recent">
            <h2 class="sectionTitle__title">{{ $t('greeting') }} {{ userData?.name }} {{ $t('greeting1') }}</h2>
            <p class="sectionTitle__text">
              {{ $t('message') }}
            </p>
          </div>

          <div class="sectionTitle mb-30" v-else>
            <h2 class="sectionTitle__title"> {{ $t("top_rated_courses") }} </h2>
            <p class="sectionTitle__text">
              {{ $t("join_thousands_of_learners") }}
            </p>
          </div>

        </div>
      </div>
    </div>

    <carousel v-bind="settings" :breakpoints="breakpoints" :autoplay="5000" :wrap-around="true" :dir="direction">
      <slide v-for="slide in latestCourses" :key="slide.uuid" class="mb-15 px-1 d-flex flex-column">
        <Coursecard :showPrice="false" :item="slide" />
      </slide>

      <template #addons>
        <pagination />
      </template>
    </carousel>

  </section>
</template>

<script>
// If you are using PurgeCSS, make sure to whitelist the carousel CSS classes
import AOS from "aos";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination } from "vue3-carousel";
import Coursecard from "../common/Coursecard.vue";
import { mapGetters } from "vuex";
//import { getLatestCourses } from "@/Services/api/CoursesService";
import Loader from "../common/Loader.vue";
export default {
  components: {
    Loader,
    Carousel,
    Slide,
    Pagination,
    Coursecard,
  },
  data() {
    return {
      direction: localStorage.getItem("direction") || "ltr",
      loading: false,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        // 700px and up
        700: {
          itemsToShow: 1,
          snapAlign: "left",
        },
        900: {
          itemsToShow: 2,
          snapAlign: "left",
        },
        // 1024 and up
        1024: {
          itemsToShow: 4,
          snapAlign: "left",
        },
      } /*********/,
    };
  },
  props: {
    latestCourses: {
      type: Array
    },
    recent: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    /* async getRecentCourse() {
       this.loading = true
       try {
         const response = await getLatestCourses();
         this.latestCourses = response.data;
       } catch (error) {
         console.log(error.message)
       } finally {
         this.loading = false
       }
     }*/
  },
  computed: {
    ...mapGetters(['currentLanguage', 'paddingAdded']),
    userData() {
      return this.$store.getters.userData;
    },

  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        //this.getRecentCourse();
      },
      immediate: true, // Run the handler immediately when the component is mounted
    }
  },
  mounted() {
    window.addEventListener("direction-localstorage-changed", (event) => {
      this.direction = event.detail.storage;
    });
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>
<style scoped>
.scroll-margin {
  margin-top: 100px;
  padding-top: 120px;
}
</style>